import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ResetPasswordDialog from "../../components/dialogs/login-dialogs/ResetPasswordDialog";
import DialogsBackground from "../../components/dialogs/DialogsBackground";

class ResetPasswordPage extends Component {
  constructor() {
    super();
    this.state = {
      isAuthenticated: false,
    };
    this.modalRef = React.createRef();
  }

  render() {
    return (
      <React.Fragment>
        <React.Fragment>
          {this.props.isModal ? (
            <div
              ref={this.modalRef}
              onClick={() => this.props.history.goBack()}
            >
              <div onClick={(e) => e.stopPropagation()}>
                <ResetPasswordDialog prevLocation={this.props.prevLocation} />
              </div>
            </div>
          ) : (
            <div>
              <DialogsBackground />
              <ResetPasswordDialog
                fullPageView={true}
                prevLocation={this.props.prevLocation}
              />
            </div>
          )}
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default withRouter(ResetPasswordPage);
